import * as React from "react";
import { getValueForSpacing } from "../styles";
export var defaultGetGutterValue = function (key) { return getValueForSpacing(key) / 2; };
export var StackLayoutContext = React.createContext({
    gutter: 3,
    getGutterValue: getValueForSpacing,
});
export var useStackLayoutContext = function () { return React.useContext(StackLayoutContext); };
